import { render, staticRenderFns } from "./Nube.vue?vue&type=template&id=151246fd"
import script from "./Nube.vue?vue&type=script&lang=js"
export * from "./Nube.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports